import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useExperiences } from 'core/contexts/experienceV2';
import { ExperienceStatus as ExpStatus } from '@utriper/core';
import { Box, Grid2, Typography } from '@mui/material';

const ExpStatusCard = ({ label, count }) => {
    return (
        <Grid2
            container
            size={{ xs: 6, sm: 3 }}
            direction="column"
            sx={{
                padding: '1em',
                borderRadius: '.5em',
                border: 'solid #13131340 1px',
                boxShadow: 'var(--shadow-card)',
                backgroundColor: '#fff',
                gap: '1em',
                minWidth: { xs: '190px', sm: '280px', lg: 'auto' },
            }}
        >
            <Grid2 container size={12}>
                <Typography fontSize={16} fontWeight={500} sx={{ color: '#131313bf' }} noWrap>
                    {label}
                </Typography>
            </Grid2>
            <Grid2 container size={12}>
                <Typography fontSize={32} fontWeight={900} sx={{ color: '#131313' }} noWrap>
                    {count}
                </Typography>
            </Grid2>
        </Grid2>
    );
};

const ExperienceStatus = () => {
    const { i18n, t: translate } = useTranslation();
    const { allExperiencesCount, experienceCounts } = useExperiences();

    const experienceStatuses = useMemo(
        () =>
            ExpStatus.getIds().map((status) => ({
                id: status,
                label: ExpStatus.getTranslatedName(ExpStatus.status, status, i18n.language),
                count: experienceCounts[`status_${status}`] ?? 0,
            })),
        [experienceCounts, i18n]
    );

    return (
        <Box component="section" display="flex" flexDirection="column" mt="16px" gap="24px">
            <Grid2
                container
                size={12}
                spacing={2}
                justifyContent="flex-start"
                alignItems="center"
                flexWrap="nowrap"
                sx={{
                    overflowX: 'auto',
                    '&::-webkit-scrollbar': { height: '8px' },
                    '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
                    '&::-webkit-scrollbar-thumb': { backgroundColor: '#888', borderRadius: '4px' },
                    '&::-webkit-scrollbar-thumb:hover': { background: '#555' },
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#888 #f1f1f1',
                }}
            >
                <ExpStatusCard label={translate('experience_list.total')} count={allExperiencesCount} />
                {experienceStatuses.map(({ id, label, count }) => (
                    <ExpStatusCard key={id} label={label} count={count} />
                ))}
            </Grid2>
        </Box>
    );
};

export default ExperienceStatus;
